import { Button, Checkbox, Col, DatePicker, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import ConfirmationBox from "../../../../../../components/common/ConfirmationBox";
import UsefulMessage from "../../../../../../components/common/UsefulMessage";

function MarkJobDone({ workOrderNumber, setIsConfirmationBoxOpen }) {
  return (
    <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
      <h2>Mark Job Done for Work Order #{workOrderNumber}</h2>
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item label="Completed On" required>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Notes">
              <TextArea rows={3} placeholder="e.g problem solved" />
              <p className="silver-text">Limit of 140 characters.</p>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <Checkbox>No Bill Needed</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <UsefulMessage message="A survey will be sent to the tenant(s) when this job is marked as done." />
          </Col>
        </Row>
        <div className="action-buttons">
          <Button type="primary">Save</Button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
      </Form>
    </ConfirmationBox>
  );
}

export default MarkJobDone;
